import React from "react";
import AddCarForm from "../../../forms/addcarform";

const AddCarMidComp=()=>{
    return(
        <AddCarForm></AddCarForm>
    )
}

export default AddCarMidComp;